<template>
  <div
    :class="tableCellClass"
  >
    <div class="input-container" v-if="state == 'edit' && !in_reserve">
      <input
        class="table-name"
        v-model="tableName"
        :disabled="state != 'edit' || in_reserve"
        :placeholder="
          $t(isHotel ? 'halls_tables.room' : 'halls_tables.table') + ' ' + index
        "
      /><input
        v-if="in_attachment"
        class="table-name"
        v-model="index"
        :disabled="state != 'edit' || in_reserve"
        :placeholder="
          $t(isHotel ? 'halls_tables.room' : 'halls_tables.table') + ' ' + index
        "
      />
    </div>

    <div v-else class="table-name-container" @click="
      toggleAttach();
      toggleReserve();
    ">
      <span class="table-name">{{
        tableName ||
          $t(isHotel ? "halls_tables.room" : "halls_tables.table") + " " + index
      }}</span>
      <span v-if="in_attachment" class="table-name">{{ index }}</span>
    </div>

    <span class="table-cell" v-if="state !== 'edit' && !isHotel && !in_reserve">
      {{ tablePlacesValue || $t("halls_tables.not_filled") }}
    </span>
    <span class="table-cell" v-if="state !== 'edit' && isHotel">
      {{ tableRoomType || $t("halls_tables.not_filled") }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    state: String,
    table: Object,
    value: [Number, String],
    index: Number,
    in_reserve: Boolean,
    in_attachment: Boolean,
    is_attached: Boolean,
    is_reserve_valid: Boolean,
  },
  methods: {
    toggleAttach() {
      this.$emit("attach");
    },
    toggleReserve() {
      this.$emit("setReserve", !this.table.for_reserve);
    },
    onNumberBlur() {
      if (this.in_reserve) this.$emit('save');
    }
  },
  computed: {
    tableCellClass() {
      return {
        "table-cell": true,
        "table-cell-edit": this.state == "edit",
        "table-cell-in-attachment": this.in_attachment,
        "table-cell-attached": this.is_attached,

        "table-cell-reserve": this.in_reserve,
        "table-cell-reserved": this.table.for_reserve && this.in_reserve,
        "table-cell-invalid":
          this.in_reserve &&
          !this.is_reserve_valid &&
          !this.value &&
          this.table.for_reserve,
      };
    },
    tablePlacesValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    tableName: {
      get() {
        return this.table.name;
      },
      set(v) {
        this.$emit("setName", v);
      },
    },

    tableRoomType: {
      get() {
        return this.table.room_type;
      },
      set(v) {
        this.$emit("setRoomType", v);
      },
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
  },
};
</script>

<style scoped>
/*
    Common Style
*/
.table-cell {
  border-radius: 0.555vh;
  font-size: 1.8vh;
  background: #1d1d1b;
  display: flex;
  flex-direction: column;
  align-items: center;
}

span.table-cell {
  width: 96%;
  height: 2.4444vh;
  display: block;
  background: #1d1d1d;
  color: #908f8d;
  font-size: 1.4444444444444444vh;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.333vh;
  margin-bottom: 3%;
}

.table-cell-input {
  width: 96%;
  border-radius: 0.333vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 2.4444vh;
  font-size: 1vh;
  border: 1px solid #1d1d1d;
  outline: none;
  background: #ffffff;
  color: #1d1d1b;
  margin-bottom: 3%;
}

.table-cell-input.bordered {
  border-radius: 0.3333vh;
  margin-top: 0.3vh;
  font-size: 1.4444444444444444vh;
}
.input-container {
  width: 96%;
  margin-top: 4%;
}
input.table-name::placeholder {
  color: #908f8d;
}
.table-name-container {
  width: 100%;
  padding: 0.555vh 0;
}
.table-name {
  background: #1d1d1d;
  border: none;
  color: #ededed;
  font-size: 2vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  outline: none;
  display: block;
  width: 100%;
  border-radius: 0.333vh;
}
.table-name:disabled::placeholder {
  color: #ededed;
}

.table-name::-webkit-input-placeholder {
  color: #ededed;
}

/*
 Edit Style
*/

.table-cell-edit {
  color: #1d1d1d;
}
.table-cell.table-cell-edit .table-name {
  color: #1d1d1b;
  background: #ffffff;
  border-radius: 0.333vh;
  padding: 0.333vh 0.5555vh 0;
}
.table-cell-in-attachment.table-cell.table-cell-edit .input-container {
  width: 100%;
}
.table-cell-in-attachment.table-cell.table-cell-edit {
  width: 100%;
}
.table-cell-in-attachment.table-cell.table-cell-edit .table-name {
  color: #1d1d1b;
  background: #ededed;
  border-radius: 0.6vh 0.6vh 0 0;
  padding: 0.333vh 0.5555vh 0;
  margin: 0 auto;
}
.table-cell-in-attachment.table-cell.table-cell-edit .table-name:last-child {
  border-radius: 0 0 0.6vh 0.6vh;
  padding: 0 0.5555vh 0.333vh;
}
.table-cell-in-attachment.table-cell.table-cell-edit input.table-cell-input {
  width: 92%;
  font-size: 1vh;
  margin-bottom: 4%;
}
.table-cell-input {
  border: 1px solid #ededed;
  margin-top: 3%;
}

.table-cell-input:disabled {
  background: #1d1d1b;
  color: #908f8d;
  border: none;
  line-height: 1.7;
}

.table-cell-input::placeholder {
  color: #908f8d;
}

/*
 Reserve
*/

.table-cell-reserve {
  cursor: pointer;
  background: #464646;
}

.table-cell-reserve .table-name {
  color: #ededed;
  background: #464646;
  border: none;
  cursor: pointer;
  border-radius: 0.6vh 0.6vh 0 0;
}

.table-cell-reserve .table-cell {
  border: none;
}

.table-cell-reserve .table-cell-input.bordered {
  margin-top: 0;
  border-radius: 0 0 0.6vh 0.6vh;
}

.table-cell-reserve:disabled {
  background: #1d1d1b;
  color: #ededed;
}

.table-cell-reserved {
  background: #129b81;
  color: #ededed;
}

.table-cell-reserved .table-name {
  background: #129b81;
  color: #ededed;
  cursor: pointer;
  /* border:1px solid #129b81; */
}

.table-cell-in-attachment {
  cursor: pointer;
  background: #464646;
}
.table-cell-in-attachment span.table-cell {
  font-size: 1vh;
  width: 92%;
  margin-bottom: 4%;
}
.table-cell-in-attachment .table-name {
  color: #ededed;
  border: none;
  cursor: pointer;
  background: #464646;
  font-size: 1.2222vh;
  width: 92%;
  margin: 0 auto;
}

.table-cell-in-attachment:disabled {
  background: #1d1d1b;
  color: #ededed;
}

.table-cell-attached {
  background: #129b81;
  color: #ededed;
}

.table-cell-attached .table-name {
  background: #129b81;
  color: #ededed;
}

.table-cell-invalid .table-cell-input::placeholder {
  color: #e2223b;
}
</style>
